module.exports = __webpack_public_path__ + "static/media/ic-mob-add-email.5278ed75.svg";